import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Communicator from 'models/communicator';
import connect from 'components/lib/connect';
import PrepositionalPhrase from '../metadata/prepositional_phrase';
import RoutingItem from 'models/routing_item';
import RoutingItemType from 'models/routing_item_type';
import RuleLink from '../metadata/rule_link';
import TaskRouting from 'models/task_routing';

class RoutingPhrases extends React.Component {
  render() {
    let { assignee, assigneeWas, itemType, taskItemId } = this.props.routingContent;

    let prepositionalPhrases = [];

    switch (itemType) {
      case RoutingItemType.ABANDONED_CALL:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of abandoned call');
        break;

      case RoutingItemType.AGENT_REQUEST:
        if (
          assigneeWas &&
          assigneeWas.routingGroupId === assignee.routingGroupId &&
          assigneeWas.agentId &&
          assignee.agentId &&
          assigneeWas.agentId !== assignee.agentId
        ) {
          this.addStolenPhrases(prepositionalPhrases);
          break;
        }

        if (!this.props.assigneeWasNames) {
          prepositionalPhrases.push({
            preposition: 'to',
            complement: getAssigneeName(this.props.assigneeNames),
          });
        } else {
          this.addAssigneePhrases(prepositionalPhrases, assignee, assigneeWas);
        }

        prepositionalPhrases.push({
          preposition: 'on',
          complement: 'request',
          suppressHighlight: true,
        });
        break;

      case RoutingItemType.DECLINED_OVER_CAPACITY_CHAT: {
        prepositionalPhrases = this.getDeclinedOverCapacityChatMessage(assignee, assigneeWas);
        break;
      }

      case RoutingItemType.AUTOMATED_ASSIGNMENT: {
        this.addAssigneePhrases(prepositionalPhrases, assignee, assigneeWas);

        let ruleComplement = <RuleLink ruleId={this.props.initiatorId} />;
        prepositionalPhrases.push({
          preposition: 'by',
          complement: ruleComplement,
        });
        break;
      }

      case RoutingItemType.BLIND_TRANSFER: {
        let assigneeWasName = this.props.initiatorName || getAssigneeName(this.props.assigneeWasNames);
        prepositionalPhrases.push({
          complement: assigneeWasName.charAt(0).toUpperCase() + assigneeWasName.slice(1),
        });
        prepositionalPhrases.push({
          complement: 'transferred the call to',
          suppressHighlight: true,
        });
        prepositionalPhrases.push({
          complement: getAssigneeName(this.props.assigneeNames),
        });
        break;
      }

      case RoutingItemType.CALL_DEVICE_ERROR:
        prepositionalPhrases = this.getReroutedPhraseOnCallDeviceError(assignee, assigneeWas);
        break;

      case RoutingItemType.CUSTOMER_ASSIGNEE_ASSIGNMENT:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of dedicated hero assignment');
        break;

      case RoutingItemType.CUSTOMER_ASSIGNEE_CHANGE: {
        prepositionalPhrases = this.getCustomerAssigneeChangeMessage();
        break;
      }

      case RoutingItemType.DECLINED_CALL:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'declined', 'call');
        break;

      case RoutingItemType.DECLINED_CHAT:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'declined', 'chat');
        break;

      case RoutingItemType.DECLINED_FB_MESSAGE:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'declined', 'Facebook message');
        break;

      case RoutingItemType.DECLINED_SMS:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'declined', 'SMS');
        break;

      case RoutingItemType.DECLINED_TWITTER:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'declined', 'Twitter DM');
        break;

      case RoutingItemType.DECLINED_WHATSAPP:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'declined', 'WhatsApp message');
        break;

      case RoutingItemType.INCOMING_CALL:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of incoming call');
        break;

      case RoutingItemType.INCOMING_CHAT:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of incoming chat');
        break;

      case RoutingItemType.INCOMING_EMAIL:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of incoming email');
        break;

      case RoutingItemType.INCOMING_SMS:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of incoming SMS');
        break;

      case RoutingItemType.INCOMING_INSTAGRAM_DIRECT:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of incoming Instagram Direct message');
        break;

      case RoutingItemType.INCOMING_FB_MESSAGE:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of incoming Facebook message');
        break;

      // legacy support for old conversations
      case RoutingItemType.INCOMING_TASK:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of task');
        break;

      case RoutingItemType.INCOMING_TWITTER:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of incoming Twitter DM');
        break;

      case RoutingItemType.INCOMING_WHATSAPP:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of incoming WhatsApp message');
        break;

      case RoutingItemType.MANUAL_ASSIGNMENT:
        this.addAssigneePhrases(prepositionalPhrases, assignee, assigneeWas);

        if (this.props.initiatorType !== Communicator.API) {
          prepositionalPhrases.push({
            preposition: 'by',
            complement: this.props.initiatorName,
          });
        }
        break;

      case RoutingItemType.MISSED_CALL:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'missed', 'call');
        break;

      case RoutingItemType.MISSED_CHAT:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'missed', 'chat');
        break;

      case RoutingItemType.MISSED_FB_MESSAGE:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'missed', 'Facebook message');
        break;

      case RoutingItemType.MISSED_SMS:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'missed', 'SMS');
        break;

      case RoutingItemType.MISSED_WHATSAPP:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'missed', 'WhatsApp message');
        break;

      case RoutingItemType.MISSED_TWITTER:
        prepositionalPhrases = this.getReroutedPhrase(assignee, assigneeWas, 'missed', 'Twitter message');
        break;

      case RoutingItemType.OFFER_CONFLICT:
        prepositionalPhrases = this.getRerouteOnOfferConflictMessage(assignee, assigneeWas);
        break;

      case RoutingItemType.OUTGOING_CALL:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of outgoing call');
        break;

      case RoutingItemType.OUTGOING_CHAT:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of outgoing chat message');
        break;

      case RoutingItemType.OUTGOING_EMAIL:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of outgoing email');
        break;

      case RoutingItemType.OUTGOING_SMS:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of outgoing SMS');
        break;

      case RoutingItemType.OUTGOING_FB_MESSAGE:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of outgoing Facebook message');
        break;

      case RoutingItemType.OUTGOING_TWITTER:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of outgoing Twitter message');
        break;

      case RoutingItemType.OUTGOING_WHATSAPP:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of outgoing WhatsApp message');
        break;

      case RoutingItemType.QUEUED_TRANSFER:
        this.addAssigneePhrases(prepositionalPhrases, assignee, assigneeWas);

        prepositionalPhrases.push({
          preposition: 'by',
          complement: 'system',
          suppressHighlight: true,
        });
        break;

      case RoutingItemType.REROUTED_OFFLINE:
      case RoutingItemType.UNASSIGNED_OFFLINE:
        prepositionalPhrases = this.getReassignedAgentOfflineMessage(assignee, assigneeWas);
        break;

      case RoutingItemType.REROUTED_UNASSIGNED:
        prepositionalPhrases = this.getReroutedUnassignedMessage(assignee, assigneeWas, taskItemId);
        break;

      // legacy support for old conversations
      case RoutingItemType.SLA_UPDATE:
        prepositionalPhrases.push({
          preposition: 'from',
          complement: _(this.props.assigneeWasNames).get('routingGroup'),
        });

        prepositionalPhrases.push({
          preposition: 'to',
          complement: this.props.assigneeNames.routingGroup,
        });

        prepositionalPhrases.push({
          preposition: 'because',
          complement: 'of higher SLA',
          suppressHighlight: true,
        });
        break;

      case RoutingItemType.VOICEMAIL:
        this.addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, 'of incoming voicemail');
        break;

      case RoutingItemType.REASSIGNED_CHAT:
        prepositionalPhrases = this.getChatReassignedMessage();
        break;

      case RoutingItemType.DECLINED_REASSIGNED_CHAT:
        prepositionalPhrases = this.getDeclinedReassignedChatMessage();
        break;

      default:
        break;
    }
    return (
      <span className="routingPhrases">
        {prepositionalPhrases.map((phrase, i) => (
          <PrepositionalPhrase {...phrase} key={i} />
        ))}
      </span>
    );
  }

  addAssigneePhrases(prepositionalPhrases, assignee, assigneeWas) {
    let hasAgentChanged = this.hasAgentAssignmentChanged(assigneeWas, assignee);
    let hasGroupChanged = this.hasGroupAssignmentChanged(assigneeWas, assignee);

    let complement1;
    let complement2;

    // hasAgentChanged is false if there was previously no assignee
    if (!hasAgentChanged && !hasGroupChanged) {
      complement1 = getAssigneeName(this.props.assigneeWasNames);
      complement2 = getAssigneeName(this.props.assigneeNames);
    } else if (hasAgentChanged) {
      complement1 = getAssigneeName(this.props.assigneeWasNames);
      complement2 = getAssigneeName(this.props.assigneeNames);
    } else {
      complement1 = _(this.props.assigneeWasNames).get('routingGroup');
      complement2 = this.props.assigneeNames.routingGroup;
    }

    prepositionalPhrases.push({
      preposition: 'from',
      complement: complement1,
    });

    prepositionalPhrases.push({
      preposition: 'to',
      complement: complement2,
    });
  }

  addStolenPhrases(prepositionalPhrases) {
    const assigneeWas = getAssigneeName(this.props.assigneeWasNames);
    prepositionalPhrases.push({
      preposition: 'to',
      complement: getAssigneeName(this.props.assigneeNames),
    });
    prepositionalPhrases.push({
      preposition: 'because',
      complement: assigneeWas,
      suppressHighlight: true,
    });
    prepositionalPhrases.push({
      preposition: assigneeWas === 'you' ? 'were' : 'was',
      complement: 'offline',
      suppressHighlight: true,
    });
  }

  addIncomingPhrases(prepositionalPhrases, assigneeWas, assignee, becauseComplement) {
    if (assigneeWas && assigneeWas.routingGroupId && assigneeWas.routingGroupId !== assignee.routingGroupId) {
      prepositionalPhrases.push({
        preposition: 'from',
        complement: this.props.assigneeWasNames.routingGroup,
      });
    }

    prepositionalPhrases.push({
      preposition: 'to',
      complement: this.getChangedAssigneeName(assigneeWas, assignee),
    });

    prepositionalPhrases.push({
      preposition: 'because',
      complement: becauseComplement,
      suppressHighlight: true,
    });
  }

  getDeclinedReassignedChatMessage() {
    let prepositionalPhrases = [];

    prepositionalPhrases.push({
      complement: _.upperFirst(getAssigneeName(this.props.assigneeNames)),
    });

    prepositionalPhrases.push({
      complement: 'declined the assignment',
      suppressHighlight: true,
    });

    return prepositionalPhrases;
  }

  getDeclinedOverCapacityChatMessage(assignee, assigneeWas) {
    let prepositionalPhrases = [];

    prepositionalPhrases.push({
      preposition: 'to',
      complement: this.getChangedAssigneeName(assigneeWas, assignee),
    });

    prepositionalPhrases.push({
      preposition: 'because',
      complement: getAssigneeName(this.props.assigneeWasNames),
    });

    prepositionalPhrases.push({
      complement: `exceeded chat capacity`,
      suppressHighlight: true,
    });

    return prepositionalPhrases;
  }

  getChatReassignedMessage() {
    let prepositionalPhrases = [];

    prepositionalPhrases.push({
      preposition: 'Assigned from',
      complement: _.upperFirst(getAssigneeName(this.props.assigneeWasNames)),
    });

    prepositionalPhrases.push({
      preposition: 'to',
      complement: getAssigneeName(this.props.assigneeNames),
    });

    return prepositionalPhrases;
  }

  getReroutedPhrase(assignee, assigneeWas, reason, channel) {
    return [
      {
        preposition: 'to',
        complement: this.getChangedAssigneeName(assigneeWas, assignee),
      },
      {
        preposition: 'because',
        complement: getAssigneeName(this.props.assigneeWasNames),
      },
      {
        complement: `${reason} the ${channel}`,
        suppressHighlight: true,
      },
    ];
  }

  getReroutedPhraseOnCallDeviceError(assignee, assigneeWas) {
    return [
      {
        preposition: 'to',
        complement: this.getChangedAssigneeName(assigneeWas, assignee),
      },
      {
        preposition: 'because',
        complement: (
          <a href={'https://help.gladly.com/docs/cant-accept-calls'} target="_blank" rel="noreferrer">
            Gladly Voice browser connection failed
          </a>
        ),
      },
    ];
  }

  getCustomerAssigneeChangeMessage() {
    let prepositionalPhrases = [];

    prepositionalPhrases.push({
      preposition: 'from',
      complement: getAssigneeName(this.props.assigneeWasNames),
    });

    prepositionalPhrases.push({
      preposition: 'to',
      complement: getAssigneeName(this.props.assigneeNames),
    });

    prepositionalPhrases.push({
      preposition: 'due to',
      complement: 'updated dedicated hero assignment',
      suppressHighlight: true,
    });

    return prepositionalPhrases;
  }

  getRerouteOnOfferConflictMessage(assignee, assigneeWas) {
    return [
      {
        preposition: 'to',
        complement: this.getChangedAssigneeName(assigneeWas, assignee),
      },
      {
        preposition: 'because',
        complement: getAssigneeName(this.props.assigneeWasNames),
      },
      {
        complement: 'had a conflicting offer',
        suppressHighlight: true,
      },
    ];
  }

  getReassignedAgentOfflineMessage(assignee, assigneeWas) {
    return [
      {
        preposition: 'to',
        complement: this.getChangedAssigneeName(assigneeWas, assignee),
      },
      {
        preposition: 'because',
        complement: getAssigneeName(this.props.assigneeWasNames),
      },
      {
        complement: 'went offline',
        suppressHighlight: true,
      },
    ];
  }

  getReroutedUnassignedMessage(assignee, assigneeWas, taskItemId) {
    return [
      {
        preposition: 'from',
        complement: getAssigneeName(this.props.assigneeWasNames),
      },
      {
        preposition: 'to',
        complement: this.getChangedAssigneeName(assigneeWas, assignee),
      },
      {
        preposition: 'because',
        complement: taskItemId ? 'of task reassignment' : 'of conversation reassignment',
        suppressHighlight: true,
      },
    ];
  }

  hasAgentAssignmentChanged(assigneeWas, assignee) {
    if (!assigneeWas || !assigneeWas.agentId) {
      return assignee.agentId;
    }
    if (assignee.agentId) {
      return assignee.agentId !== assigneeWas.agentId;
    }
    return false;
  }

  hasGroupAssignmentChanged(assigneeWas, assignee) {
    if (!assigneeWas || !assigneeWas.routingGroupId) {
      return assignee.routingGroupId;
    }
    if (assignee.routingGroupId) {
      return assignee.routingGroupId !== assigneeWas.routingGroupId;
    }
    return false;
  }

  getChangedAssigneeName(assigneeWas, assignee) {
    if (this.hasAgentAssignmentChanged(assigneeWas, assignee)) {
      return this.props.assigneeNames.agent;
    }
    return this.props.assigneeNames.routingGroup;
  }
}

const assigneeNamesPropType = PropTypes.shape({ agent: PropTypes.string, routingGroup: PropTypes.string.isRequired });
const routingContentPropType = PropTypes.oneOfType([
  PropTypes.instanceOf(RoutingItem),
  PropTypes.instanceOf(TaskRouting),
]);

RoutingPhrases.propTypes = {
  assigneeNames: assigneeNamesPropType.isRequired,
  assigneeWasNames: assigneeNamesPropType,
  initiatorId: PropTypes.string,
  initiatorType: PropTypes.string,
  initiatorName: PropTypes.string,
  routingContent: routingContentPropType.isRequired,
};

function getAssigneeName(assigneeNames) {
  return assigneeNames && (assigneeNames.agent || assigneeNames.routingGroup);
}

const RoutingPhrasesContainer = connect(mapStateToProps)(RoutingPhrases);

function mapStateToProps({ getProvider, isFeatureEnabled }, { initiatorId, routingContent, initiatorType }) {
  return {
    assigneeNames: getAssigneeNames(routingContent.assignee),
    assigneeWasNames: routingContent.assigneeWas && getAssigneeNames(routingContent.assigneeWas),
    initiatorId,
    initiatorType,
    initiatorName: initiatorId && getNameOrYou(initiatorId),
    routingContent,
  };

  function getAssigneeNames({ agentId, routingGroupId }) {
    return {
      agent: agentId && getNameOrYou(agentId),
      routingGroup: getRoutingGroupName(routingGroupId),
    };
  }

  function getNameOrYou(agentId) {
    return agentId === getCurrentAgentId() ? 'you' : getAgentName(agentId);
  }

  function getCurrentAgentId() {
    return getProvider('currentAgent').get().id;
  }

  function getAgentName(agentId) {
    let agent = getProvider('agents').findBy({ id: agentId });
    return agent ? agent.getDisplayName() : '';
  }

  function getRoutingGroupName(routingGroupId) {
    let group = getProvider('routingGroups').findBy({ id: routingGroupId });
    return group ? group.name : '';
  }
}

RoutingPhrasesContainer.propTypes = {
  initiatorId: PropTypes.string,
  routingContent: routingContentPropType.isRequired,
};

export default RoutingPhrasesContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/routing/routing_phrases.jsx